var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-area",attrs:{"data-aos":"my-fade","data-aos-delay":"150","data-aos-duration":"500","data-aos-anchor-placement":"top-bottom"}},[_c('dl',[_c('dt',[_vm._t("title")],2),_c('dd',[_vm._t("sub-title")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }